/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useRef, useEffect } from 'react';
import Container from 'container';
import Headline from 'headline';
import useProduct from 'hooks/useProduct';
import Img from 'img';
import Icon from 'icon';
import Button from 'button';
import Select from 'shared/form-input/select';
import Counter from 'shared/counter';
import Rating from 'shared/rating';
import FAQS from 'components/templates-default/faq';
// import useKlaviyo from 'hooks/useKlaviyo';
import RichSnippet from 'seo-schema';
import HeroCohort from 'components/templates-default/cohort-hero';
import Breadcrumbs from 'components/templates-default/breadcrumbs';
import useCustomerAccessToken from 'hooks/useCustomerAccessToken';
import useGlobal from 'hooks/useGlobal';
import Chart from './chart';
import excerptVideoLinksMap from './exerptVideoLinksMap';

import s from './page-product.module.scss';

function parseDiscount(discount) {
  return discount && discount.includes('-') ? discount.replace(/-/g, '') : discount;
}

function Flag({ text, color }) {
  return (
    <div className={`${s.flag} ${s[color]}`}>
      <div>{text}</div>
    </div>
  );
}

export default function PageProduct(props) {
  const { state, emit } = useGlobal();
  const parentBreadCrumb = props.location?.state?.link && props.location.state;
  const [changedOnce, setChangedOnce] = useState(false);
  const { customerAccessToken } = useCustomerAccessToken();

  // const { trackProduct } = useKlaviyo();
  const product = useProduct({ ...props, variantId: props?.variants[0]?.id }, { refreshProduct: true });
  const {
    title,
    image,
    images,
    priceString,
    descriptionHtml,
    optionList,
    options,
    handleChange: onSelectChange,
    submitMethod,
    counter,
    spin,
    activePrice,
    submitReady,
    adminId,
    rating,
    reviews,
    reviewCount,
    addReview,
    refreshReviews,
    faqs,
    productInfo,
    recommendedProducts,
    featuredCollection,
    ...other
  } = product;

  const isEndoProduct = Boolean(featuredCollection === 'EndoCanna Health');

  const handleChange = async e => {
    await onSelectChange(e);
    setChangedOnce(true);
  };

  const { excerpt, description, ...infoTabs } = productInfo;
  const tabs = Object.keys(infoTabs).filter(tab => infoTabs[tab]);
  const [tab, setTab] = useState(tabs[0] && infoTabs[tabs[0]]);
  const [activeImage, setActiveImage] = useState(image);
  const reviewsRef = useRef();
  const scrollToReviews = () => {
    reviewsRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };
  const mappedFaqs =
    faqs &&
    faqs.reduce((acc, { questions, answers }) => {
      const faqs = questions.map((question, idx) => ({
        question,
        answer: answers[idx]
      }));
      return [...acc, ...faqs];
    }, []);
  useEffect(() => {
    // trackProduct(product);
  }, []);
  const initialFlags =
    product?.selectedOption?.flags || product?.selectedOption?.soldOut;
  const notAvailable =
    changedOnce &&
    product.hasOptions &&
    !product.activePrice &&
    Object.keys(options).filter(option => options[option]).length ===
    optionList.length;
  const hasFlags = notAvailable
    ? { color: 'grey', text: 'Sold Out' }
    : initialFlags;
  const ActivePrice = () => {
    return hasFlags && hasFlags.compareAtPrice ? (
      <>
        <span className={s.compareAtPrice}>${hasFlags.compareAtPrice}</span>
        <span className={s.discount}>-{parseDiscount(hasFlags.amount)}%</span>
        <span className={s.priceString}>
          {activePrice && optionList ? `$${activePrice}` : priceString}
        </span>
      </>
    ) : (
      <>{activePrice && optionList ? `$${activePrice}` : priceString}</>
      );
  };
  const { slug } = props;
  const hasVideoLinks = excerptVideoLinksMap[slug] || false;
  return (
    <main className={s.root}>
      <RichSnippet
        product
        {...{
          title,
          excerpt,
          slug,
          activePrice,
          image,
          notAvailable,
          initialFlags
        }}
      />
      <HeroCohort title="Product" />
      <Breadcrumbs
        pages={[
          { name: 'Products', href: '/' },
          { name: title, href: `/product/${slug}` }
        ]}
      />
      <Container className={s.productContainer}>
        <div className={s.product}>
          <Headline h3 el="h1" className={s.headline}>
            {title}
          </Headline>
          <div className={s.productDetails}>
            <div className={s.image}>
              {/* {hasFlags && (
                <Flag
                  {...(notAvailable ? hasFlags : product.selectedOption.flags)}
                />
              )} */}
              {images.length > 1 && (
                <div className={s.thumbnails}>
                  {images.map(image => (
                    <div
                      role="button"
                      tabIndex="-1"
                      onClick={() => setActiveImage(image)}
                      className={`${s.thumbnail} ${
                        activeImage === image ? s.active : ''
                        }`}
                      key={image}
                    >
                      <Img
                        src={image}
                        resize
                        className={s.thumbnailImg}
                        ratio={0.1}
                      />
                    </div>
                  ))}
                </div>
              )}
              <Img
                src={activeImage}
                ratio={0.5}
                preloadImages={
                  activeImage === image &&
                  images &&
                  images.length > 0 &&
                  images.filter(img => img !== image)
                }
                className={`${s.img} ${
                  images.length > 1 ? s.hasThumbnails : ''
                  }`}
              />
              {!isEndoProduct && (
              <img
                src="/svg/icon-row.svg"
                alt="icon-row"
                className={s.iconsRow}
              />
)}
              <button
                type="buton"
                className={s.enlargeButton}
                onClick={() => {
                  emit.update({
                    showFullImage: true,
                    fullImage: activeImage
                  });
                }}
              >
                Click for full image
              </button>
            </div>
            <div className={s.info}>
              <Headline h3 el="h1" className={`${s.headline} ${s.desktop}`}>
                {title}
              </Headline>
              {customerAccessToken && (
                <p className={s.price}>
                  <ActivePrice />
                </p>
              )}
              {excerpt && (
                <div
                  className={s.excerpt}
                  dangerouslySetInnerHTML={{ __html: excerpt.body }}
                />
              )}
              {hasVideoLinks && hasVideoLinks.map(({ name, src }) => (
                <span
                  onClick={() => {
                  emit.update({
                    showPopupVimeoVideo: { name, src }
                  });
                }}
                  className={s.videoLink}
                >{name}
                </span>
              ))}
              <form
                onSubmit={
                  product.soldOut ? e => e.preventDefault() : (e) => { console.log(e); submitMethod(e); }
                }
                className={s.form}
              >
                {/* {optionList &&
                  optionList.map(option => {
                    return (
                      <div className={s.selectContainer} key={option.name}>
                        <div className={s.selectOverlay}>
                          {options[option.name] ? (
                            <span>
                              <span>{option.name} </span> {options[option.name]}
                            </span>
                          ) : (
                            <span>
                              <span>{option.name} </span> {options[option.name]}
                            </span>
                          )}
                          <Icon icon="caret" className={s.caret} />
                        </div>
                        <Select
                          noMask
                          light
                          className={s.select}
                          id={option.name}
                          placeholder=""
                          onChange={handleChange}
                          name={option.name}
                          value={options[option.name]}
                        >
                           <option value="">Choose an option</option>
                          {option.values.map(value => (
                            <option value={value} key={value}>
                              {value}
                            </option>
                          ))}
                        </Select>
                      </div>
                    );
                  })} */}
                <div
                  className={`${s.countWrapper} ${
                    optionList ? s.withMargin : ''
                    }`}
                >
                  <Counter counter={counter} />
                  <Button
                    fallbackText="LEARN MORE"
                    className={s.submit}
                    disabled={
                      !submitReady
                      // product.soldOut
                      // product?.selectedOption?.soldOut v1
                    }
                    small
                    type="submit"
                  >
                    <span className={spin ? s.hide : ''}>Add to cart</span>
                    {spin && (
                      <span className={s.spinner}>
                        <Icon icon="spinner" className="animate-spin" />
                      </span>
                    )}
                  </Button>
                </div>
              </form>
              {description && (
                <div
                  className={`${s.description} ${s.infoContainer}`}
                  dangerouslySetInnerHTML={{ __html: description.body }}
                />
              )}
              {!isEndoProduct && (
              <img
                src="/svg/icon-row.svg"
                alt="icon-row"
                className={`${s.iconsRow} ${s.mobile}`}
              />
              )}
            </div>
          </div>
        </div>
      </Container>
      <Chart {...productInfo} />
      {/* <FAQComponent mappedFaqs={mappedFaqs} /> */}
    </main>
  );
}

function FAQComponent({ mappedFaqs }) {
  const [slice, setSlice] = useState(4);

  return (
    <FAQS
      questions={mappedFaqs.slice(0, slice)}
      title="We Have Answers"
      small_title="Got Questions?"
    >
      {slice < mappedFaqs.length && (
        <div className={s.faqButton}>
          <Button outline onClick={() => setSlice(mappedFaqs.length)}>
            More Questions
          </Button>
        </div>
      )}
    </FAQS>
  );
}
